import React from "react";
import { handleChangeFile } from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import PropTypes from "prop-types";

function AprovarDemissaoModal({
  isOpen,
  setIsOpen,
  valuesHook,
  aprovarDemissao,
}) {
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={"Aprovar demissão"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="md"
      buttons={
        <CommonButton
          key={`aprovar-demissao`}
          onClick={() => aprovarDemissao(values?.tipo_demissao, values?.categoria)}
          color="success"
        >
          Aprovar demissão
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-7 mb-3">
          <CommonInputFile
            id="termoRescisao"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            label="Termo de rescisão"
            accept="application/pdf"
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-7 mb-3">
          <CommonInputFile
            id="extratoFgts"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            label="Extrato FGTS"
            accept="application/pdf"
            required
          />
        </div>
      </div>
      {(![1, 2, 3, 4].includes(values?.tipo_demissao) || values?.categoria === 2) && (
        <div className="row">
          <div className="col-md-7 mb-3">
            <CommonInputFile
              id="fgts"
              onChange={(e) => handleChangeFile(e, values, setValues)}
              label="Demonstrativo FGTS"
              accept="application/pdf"
              required
            />
          </div>
        </div>
      )}
      {(![2, 3].includes(values?.tipo_demissao) || values?.categoria === 2) && (
        <div className="row">
          <div className="col-md-7 mb-3">
            <CommonInputFile
              id="seguroDesemprego"
              onChange={(e) => handleChangeFile(e, values, setValues)}
              label="Requerimento do seguro desemprego"
              accept="application/pdf"
              required
            />
          </div>
        </div>
      )}
      {(values?.tipo_demissao !== 2 || values?.categoria === 2) && (
        <div className="row">
          <div className="col-md-7 mb-3">
            <CommonInputFile
              id="avisoPrevio"
              onChange={(e) => handleChangeFile(e, values, setValues)}
              label="Aviso prévio"
              accept="application/pdf"
              required
            />
          </div>
        </div>
      )}
    </CommonModal>
  );
}

AprovarDemissaoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  aprovarDemissao: PropTypes.func.isRequired,
};

export default AprovarDemissaoModal;
